/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { RefinerComponent, SearchBarComponent } from '@msdyn365-commerce/components';
import * as React from 'react';

import { IOrderHistoryWithSearchAndFiltersViewProps } from './order-history-with-search-and-filters';
import {
    OrderHistoryWithSearchAndFiltersHeaderComponent,
    OrderHistoryWithSearchAndFiltersOrganizationWideSelectorComponent
} from './components';

const OrderHistoryWithSearchAndFiltersView: React.FC<IOrderHistoryWithSearchAndFiltersViewProps> = props => {
    const {
        orderHistoryWithSearchAndFiltersProps,
        headerProps,
        organizationWideSelectorProps,
        searchBarProps,
        refinerProps,
        alert,
        loading,
        emptyMessage,
        backToShoppingLink,
        list,
        table,
        moreButton
    } = props;

    return (
        <Module {...orderHistoryWithSearchAndFiltersProps}>
            {headerProps && <OrderHistoryWithSearchAndFiltersHeaderComponent {...headerProps} />}
            {searchBarProps && <SearchBarComponent {...searchBarProps} />}
            {organizationWideSelectorProps && (
                <OrderHistoryWithSearchAndFiltersOrganizationWideSelectorComponent {...organizationWideSelectorProps} />
            )}
            {refinerProps && <RefinerComponent {...refinerProps} />}
            {loading}
            {alert && (
                <>
                    {alert}
                    {backToShoppingLink}
                </>
            )}
            {emptyMessage && (
                <Node className='ms-order-history-with-search-and-filters__empty-message-container'>
                    {emptyMessage}
                    {backToShoppingLink}
                </Node>
            )}
            {list}
            {table}
            {moreButton && moreButton}
        </Module>
    );
};

export default OrderHistoryWithSearchAndFiltersView;
